const ru = {
  kicker: "Тестовая версия",
  title: "Играйте в Trollfossjakten уже сейчас через Expo Go.",
  lead: "Мы тестируем приложение и завершаем партнёрские соглашения. Полная версия выйдет в App Store и Google Play до 1 февраля 2027 года. А пока вы можете бесплатно играть в тестовую версию.",
  notice: "Тестовая версия — до запуска возможны изменения",
  step1: "Установите Expo Go",
  step1Body: "Expo Go — бесплатное приложение, в котором работает наша тестовая версия. Скачайте его в своём магазине приложений.",
  step2: "Отсканируйте код",
  step2Body: "iPhone: отсканируйте код приложением «Камера». Android: откройте Expo Go и нажмите «Scan QR code».",
  step3: "Или откройте ссылку на телефоне",
  step3Body: "Expo Go уже установлен? Нажмите кнопку на телефоне, чтобы сразу открыть тестовую версию.",
  open: "Открыть в Expo Go",
  copyLink: "Копировать ссылку",
  copied: "Ссылка скопирована",
  qrAlt: "QR-код тестового приложения Trollfossjakten",
  dlTitle: "Скачайте тестовую версию",
  dlExpo: "1 · Установите Expo Go (бесплатно)",
  dlOpen: "2 · Откройте наше тестовое приложение",
  dlLink: "Прямая ссылка",
  qrCaption: "Отсканируйте, чтобы открыть тестовую версию",
};

export default ru;
